import DocsRejectModal from './styled';

export default DocsRejectModal;
